<template>
<div>
    <div class="row">
        <div class="mb-4">
            <label class="form-label">고시원 옵션 (다중 선택 가능) <span class="text-danger">*</span></label>
            <div class="d-flex flex-wrap gap-2">
                <button type="button" class="btn btn-outline-info" v-for="(type, idx) in options" :key="`options_${idx}`" :class="{'custom-btn-5' : isWideScreen, 'active' : type.checked}" @click="type.checked=!type.checked">
                    {{ type.text }}
                </button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4">
            <div class="mb-4">
                <label class="form-label">사용자 구분 <span class="text-danger">*</span></label>
                <div class="d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-outline-info" v-for="(type, idx) in useSexType_options" :key="`sex_${idx}`" :class="{'custom-btn-4' : isWideScreen, 'active' : type.checked}" @click="changeType(type, 'useSexType_options')">
                        {{ type.text }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="mb-4">
                <label class="form-label">난방 타입 <span class="text-danger">*</span></label>
                <div class="d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-outline-info" v-for="(type, idx) in heatingType_options" :key="`heating_${idx}`" :class="{'custom-btn-3' : isWideScreen, 'active' : type.checked}" @click="changeType(type, 'heatingType_options')">
                        {{ type.text }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="mb-4">
                <label class="form-label">룸 타입 (다중 선택 가능) <span class="text-danger">*</span></label>
                <div class="d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-outline-info" v-for="(type, idx) in roomType_options" :key="`roomType_${idx}`" :class="{'custom-btn-3' : isWideScreen, 'active' : type.checked}" @click="type.checked=!type.checked">
                        {{ type.text }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">지하철 정보</label>
                <div class="avatar-lg" @click="addSubway()">
                    <span class="avatar-title avatar-title-custom text-secondary font-14 rounded">
                        <i class="mdi mdi-subway-variant mdi-24px"></i>
                        지하철 추가
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="row" v-show="kosiwon.traffics_subway.filter(item => !item.is_deleted).length > 0">
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">지하철 정보를 입력해주세요.</label>
                <div class="row mb-2" v-for="(subway, idx) in kosiwon.traffics_subway.filter(item => !item.is_deleted)" :key="`subway_${idx}`">
                    <div class="col-4">
                        <select class="form-select" v-model="subway.station_number">
                            <option value="" disabled selected>호선</option>
                            <option v-for="line in subwayLine_list" :value="line">
                                {{ line }}
                            </option>
                        </select>
                    </div>
                    <div class="col-8">
                        <div class="input-group">
                            <input class="form-control" type="text" placeholder="역 이름을 입력해주세요." v-model="subway.intro" />
                            <span class="input-group-text" @click="delSubway(subway, idx)">
                                <i class="mdi mdi-trash-can-outline"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ul class="list-inline wizard mb-0">
        <li class="list-inline-item float-end">
            <a href="javascript:void(0);" class="btn btn-info button-next me-1 d-none d-sm-inline">사진 정보 입력하기 <i class="mdi mdi-arrow-right ms-1"></i></a>
            <button type="button" class="btn btn-info" @click="$emit('open-confirm-modal')">{{ btnText }}</button>
        </li>
    </ul>
</div>
</template>

<script>
export default {
    props: [
        "kosiwon",
        "options",
        "useSexType_options",
        "heatingType_options",
        "roomType_options",
        "isWideScreen",
        "btnText"
    ],
    data() {
        return {
            subwayLine_list: [
                "1", "2", "3", "4", "5", "6", "7", "8", "9",
                "인천1", "인천2", "분당", "신분당", "경의중앙", "공항철도",
                "경춘", "의정부", "용인", "경강", "우이신설", "서해",
                "김포골드", "신림"
            ]
        }
    },
    methods: {
        changeType(type, target) {
            this[target].forEach(option => {
                option.checked = option.value === type.value;
            });
        },
        addSubway() {
            if (this.kosiwon.traffics_subway.filter(subway => !subway.is_deleted).length >= 3) {
                alert("지하철 정보는 최대 3개까지 입력 가능합니다.");
            } else {
                this.kosiwon.traffics_subway.push({
                    station_number: "", // 호선 정보 ("1", "2", "신분당"..)
                    intro: "", // 역 이름  ("회기", "역삼", "양재"..)
                    description: "", // ""
                    is_deleted: 0 // 삭제 여부 (0 || 1)
                });
            }
        },
        delSubway(subway, idx) {
            if (confirm("지하철 정보를 삭제하시겠습니까?")) {
                if (subway.hasOwnProperty("pk")) {
                    subway.is_deleted = 1;
                } else {
                    this.kosiwon.traffics_subway.splice(idx, 1);
                }
            }
        }
    }
}
</script>

<style>
.custom-btn-5 {
    width: calc(100%/5 - 10px);
}

.custom-btn-4 {
    width: calc(100%/4 - 10px);
}

.custom-btn-3 {
    width: calc(100%/3 - 10px);
}
</style>
